module.exports = __webpack_public_path__ + "img/palmas-restaurant-2.70a71beb.jpg";